import React from 'react';
import { IButtonProps } from './types';

const GlassyButton: React.FC<IButtonProps> = ({
    text,
    className,
    style,
    gradientColors,
    isActive = false,
    ...props
}) => {
    const buttonStyle = {
        ...style,
        border: '1px solid white',
        borderRadius: '4px',
        padding: '2px 8px',
        color: 'white',
    };
    const activeColors = ['blue', 'lightblue'];
    const defaultColors = ['#e4d6d6', 'lightgray'];
    const colors = gradientColors || (isActive ? activeColors : defaultColors) ;
    buttonStyle.backgroundImage = `linear-gradient(${colors.join(',')})`;
    return <div className={className} style={buttonStyle} {...props}>{text}</div>
}

export default GlassyButton;